export const CALENDLY_CONFIG = {
  url: 'https://calendly.com/d/cwkv-h45-mnq/frame-io-enterprise-sales-meetings-in-app',
  scriptSrc: 'https://assets.calendly.com/assets/external/widget.js',
  cssSrc: 'https://assets.calendly.com/assets/external/widget.css',
  scriptId: 'calendly-widget-script',
  cssId: 'calendly-widget-css',
  pollInterval: 100,
} as const;
